// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"596":"d66aee7d","756":"66f57516"}[chunkId] + ".chunk.js";
};